import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

import { User } from '../../../user/User.interface';

const Styled = {
  Email: styled.span`
    text-transform: lowercase;
  `,
  Name: styled.span`
    text-transform: capitalize;
  `
};

interface UserLinkProps {
  user?: User;
  type: 'name' | 'email';
  disableLink?: boolean;
}

const UserLink: React.FunctionComponent<UserLinkProps> = ({
  user,
  type,
  disableLink
}) => {
  if (!user) {
    return null;
  }
  const displayText =
    type === 'email' ? (
      <Styled.Email>{user.email}</Styled.Email>
    ) : (
      <Styled.Name>
        {user.firstName} {user.lastName}
      </Styled.Name>
    );
  return disableLink ? (
    displayText
  ) : (
    <Link to={`/portal/users/${user.id}`}>{displayText}</Link>
  );
};

export default UserLink;
